// src/hooks/useFormatter.js
import { useCallback } from "react";

export const useFormatter = () => {
  // ✅ Formatear precios
  const formatPrice = useCallback((value, currency = "COP") => {
    return new Intl.NumberFormat("es-CO", {
      style: "currency",
      currency: currency,
      minimumFractionDigits: 0,
    }).format(value);
  }, []);

  // ✅ Formato de fecha larga (23 de agosto de 2025)
  const formatDateLong = (dateStringUTC) => {
    if (!dateStringUTC) return ""; // <-- evita el error si viene null o undefined

    const localDate = new Date(dateStringUTC.replace(/Z$/, ""));
    return new Intl.DateTimeFormat("es-CO", {
      year: "numeric",
      month: "long",
      day: "numeric",
    }).format(localDate);
  };

  // ✅ Formato de fecha corta (dd/mm/yyyy)
  const formatDate = useCallback((date) => {
    if (!date) return "";
    return new Intl.DateTimeFormat("es-CO", {
      timeZone: "America/Bogota", // ✅ tu zona real
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).format(new Date(date));
  }, []);

  //Metodo  no usando la zano local
  const formatDateUTC = useCallback((date) => {
    if (!date) return "";
    return new Intl.DateTimeFormat("es-CO", {
      timeZone: "UTC", // ✅ tu zona local
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).format(new Date(date));
  }, []);

  // Metodo para formatear la hora
  const formatHora = useCallback((fecha, useUTC = false) => {
    if (!fecha) return "";

    const dateObj = new Date(fecha);

    if (useUTC) {
      // Hora en UTC (sin zona local)
      return dateObj.toISOString().split("T")[1].split(".")[0]; // "13:32:47"
    }
    return dateObj.toLocaleTimeString("es-ES", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });
  }, []);

  const formatDateInput = useCallback((date, timeZone = "America/Bogota") => {
    if (!date) return "";

    const parts = new Intl.DateTimeFormat("en-CA", {
      timeZone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).formatToParts(new Date(date));

    const year = parts.find((p) => p.type === "year")?.value;
    const month = parts.find((p) => p.type === "month")?.value;
    const day = parts.find((p) => p.type === "day")?.value;

    return `${year}-${month}-${day}`;
  }, []);

  // Formatea fecha+hora para un input type="datetime-local" (yyyy-MM-ddTHH:mm)
  const formatDateTimeInput = useCallback((date, timeZone = "America/Bogota") => {
    if (!date) return "";

    const parts = new Intl.DateTimeFormat("en-CA", {
      timeZone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    }).formatToParts(new Date(date));

    const get = (type) => parts.find((p) => p.type === type)?.value;

    return `${get("year")}-${get("month")}-${get("day")}T${get("hour")}:${get("minute")}`;
  }, []);

  // Fecha y hora actuales listas para un input datetime-local
  const getNowDateTimeInput = useCallback(
    (timeZone = "America/Bogota") => formatDateTimeInput(new Date(), timeZone),
    [formatDateTimeInput],
  );

  // Formato de fecha+hora legible (dd/mm/yyyy hh:mm)
  const formatDateHora = useCallback((date, timeZone = "America/Bogota") => {
    if (!date) return "";
    return new Intl.DateTimeFormat("es-CO", {
      timeZone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    }).format(new Date(date));
  }, []);

  const formtTodayBogota = useCallback(() => {
    const parts = new Intl.DateTimeFormat("en-CA", {
      timeZone: "America/Bogota",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).formatToParts(new Date());

    const year = parts.find((p) => p.type === "year")?.value;
    const month = parts.find((p) => p.type === "month")?.value;
    const day = parts.find((p) => p.type === "day")?.value;

    return `${year}-${month}-${day}`;
  }, []);

  return {
    formatPrice,
    formatDateLong,
    formatDate,
    formatHora,
    formatDateUTC,
    formtTodayBogota,
    formatDateInput,
    formatDateTimeInput,
    getNowDateTimeInput,
    formatDateHora,
  };
};;

//formatDate → mostrar fechas normales en pantalla
//formatDateUTC → mostrar fechas de factura sin corrimiento
//formatDateInput → llenar inputs type="date"
//getTodayBogota → filtros por defecto de hoy
//formatHora → mostrar hora
//formatPrice → dinero